import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

// 用于接收resumejson数据和模板名称的Schema
export const jsonResumeToPdfSchema = z.object({
  jsonResume: z.any(), // 接收任何JSON格式的数据，将由JsonResumeParser验证和转换
  templateName: z.string().optional(), // 可选的模板名称
});

export class JsonResumeToPdfDto extends createZodDto(jsonResumeToPdfSchema) {}
